import {journalPhotoToRow} from './journal-photo.js';

function safeCode(error,fallback){
  return String(error?.code||fallback).slice(0,80);
}

function remoteError(error,code){
  const wrapped=new Error(code);
  wrapped.code=safeCode(error,code);
  wrapped.cause=error;
  return wrapped;
}

function sameTimestamp(left,right){
  if(left==null||right==null)return left==null&&right==null;
  const a=Date.parse(String(left));
  const b=Date.parse(String(right));
  return !Number.isNaN(a)&&!Number.isNaN(b)&&a===b;
}

function sameRow(expected,remote){
  if(!remote)return false;
  return String(remote.id)===String(expected.id)
    &&String(remote.user_id)===String(expected.user_id)
    &&String(remote.session_id)===String(expected.session_id)
    &&String(remote.stage_id??'')===String(expected.stage_id??'')
    &&String(remote.item_id??'')===String(expected.item_id??'')
    &&String(remote.storage_path)===String(expected.storage_path)
    &&String(remote.mime_type)===String(expected.mime_type)
    &&Number(remote.size_bytes)===Number(expected.size_bytes)
    &&sameTimestamp(remote.captured_at,expected.captured_at);
}

export function createJournalMediaRemote({client}={}){
  if(!client?.from)throw new TypeError('Supabase client is required');

  async function current(id){
    const {data,error}=await client.from('smoking_journal_media')
      .select('id,user_id,session_id,stage_id,item_id,storage_path,mime_type,size_bytes,captured_at')
      .eq('id',id)
      .maybeSingle();
    if(error)throw remoteError(error,'JOURNAL_PHOTO_METADATA_READ_FAILED');
    return data||null;
  }

  async function insert(photo){
    const row=journalPhotoToRow(photo);
    const {error}=await client.from('smoking_journal_media').insert(row);
    if(!error)return Object.freeze({ok:true,status:'created'});

    if(String(error.code)==='23505'){
      const existing=await current(row.id).catch(()=>null);
      if(existing&&sameRow(row,existing)){
        return Object.freeze({ok:true,status:'already_exists',idempotent:true});
      }
      const collision=remoteError(error,'JOURNAL_PHOTO_METADATA_ID_COLLISION');
      collision.code='JOURNAL_PHOTO_METADATA_ID_COLLISION';
      throw collision;
    }

    throw remoteError(error,'JOURNAL_PHOTO_METADATA_FAILED');
  }

  async function remove(photo){
    const row=journalPhotoToRow(photo);
    const {error}=await client.from('smoking_journal_media')
      .delete()
      .eq('id',row.id)
      .eq('user_id',row.user_id);
    if(error)throw remoteError(error,'JOURNAL_PHOTO_METADATA_DELETE_FAILED');
    return Object.freeze({ok:true,status:'deleted'});
  }

  return Object.freeze({insert,remove});
}
